module.exports = __webpack_public_path__ + "static/media/firetrees.8a330670.png";